import { Redirect, useFocusEffect } from 'expo-router'
import { useCallback } from 'react'
import { PublicFrontPage } from '~/components/frontpage/PublicFrontPage'
import { useAppView } from '~/components/layout/AppViewContext'
import ScreenView from '~/components/layout/ScreenView'
import { useSession } from '~/components/user/SessionProvider'

export default function Index() {
  const { setBackgroundTheme } = useAppView()

  useFocusEffect(
    useCallback(() => {
      setBackgroundTheme(0)
    }, [setBackgroundTheme])
  )

  const { session, isLoading, isAnonymous } = useSession()
  const shouldRedirectToAuthenticated = !!session?.user && !isLoading && !isAnonymous

  if (shouldRedirectToAuthenticated) {
    return <Redirect href="/(authenticated)" />
  }

  return (
    <ScreenView innerClassName="max-w-none" className="mx-0 w-full bg-transparent">
      <PublicFrontPage />
    </ScreenView>
  )
}
